<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="data"
      row-key="id"
      :height="Height">
      <el-table-column
        prop="SmsBaslik"
        label="Başlık"
        width="100">
      </el-table-column>
      <el-table-column
        prop="telefon"
        label="Telefon"
        width="100">
      </el-table-column>
      <el-table-column
        prop="icerik"
        label="İçerik">
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: true,
        Liste: null,
        data: null,
        Height: window.innerHeight - 195
      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: '_a/p/sonsms'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;
              if (this.Liste) this.data = true;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_a/comp/aiSonSms.vue